import React from 'react';
import { Box } from '@mui/material';

export interface SearchResultsProps<T> {
  items: T[];
  renderItem: (item: T, index: number) => React.ReactNode;
}

export const SearchResults = <T,>({ items, renderItem }: SearchResultsProps<T>) => {
  const content: React.ReactNode[] = [];

  items.forEach((item, index) => {
    content.push(renderItem(item, index));
  });
  return <Box>{content}</Box>;
};
